<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand to="/">BI Backoffice</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="isInRole('SmartGrabberUser')" to="/smartgrabber"
          >SmartGrabber
          </b-nav-item
          >
          <b-nav-item v-if="isInRole('GbqUser')" to="/big-query-grabber"
          >Big Query
          </b-nav-item
          >
          <!--          <b-nav-item v-if="isInRole('SmartGrabberUser')" to="/manage-dataset"-->
          <!--          >Datasets (beta)-->
          <!--          </b-nav-item-->
          <!--          >-->
          <!--          <b-nav-item v-if="isInRole('SmartGrabberUser')" to="/charts-report"-->
          <!--          >Chart Report (beta)-->
          <!--          </b-nav-item-->
          <!--          >-->
          <b-nav-item v-if="isInRole('DashboardUser') && !isInRole('BusinessPerformanceUser')" to="/brandPerformance"
          >Dashboard
          </b-nav-item
          >
          <b-nav-item v-if="isInRole('BusinessPerformanceUser')" to="/businessPerformance"
          >Dashboard
          </b-nav-item
          >
          <b-nav-item v-if="isInRole('TableauUser')" :to="{name:'Reports'}"
          >Tableau Views
          </b-nav-item
          >
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown v-if="user.isAdmin || isInRole('TableauAdmin')" class="mr-5">
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <span>Administrator</span>
            </template>
            <b-dropdown-item to="/users" v-if="user.isAdmin">User Management</b-dropdown-item>
            <b-dropdown-item to="/trustedips" v-if="user.isAdmin">Setup Trusted IPs</b-dropdown-item>
            <section>
              <b-dropdown-item to="/admin/dashboard-management" v-if="user.isAdmin">Settings</b-dropdown-item>
              <b-dropdown-item to="/admin/tableau-management" v-else-if="isInRole('TableauAdmin')">Settings
              </b-dropdown-item>
            </section>

          </b-nav-item-dropdown>
          <b-nav-item-dropdown v-if="user.isAuthenticated" right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <em>{{ user.name }}</em>
            </template>
            <b-dropdown-item href="/identity/account/manage"
            >Manage
            </b-dropdown-item
            >
            <b-dropdown-item href="#" @click="Logout">
              <span>Logout</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-else href="/identity/account/login">Login</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container fluid>
      <router-view/>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import application from '@/mixins/application';

export default {
  mixins: [application],
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    Logout() {
      axios.post('/identity/account/logout').then(function () {
        window.location.href = '/identity/account/login?ReturnUrl=%2F';
      });
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  white-space: nowrap;
  line-height: 60px;
}

.account-warning {
  max-width: 360px;
  position: fixed !important;
  top: 6em;
  right: 1em;
}
</style>
